import * as React from "react";
import {cx}       from "emotion";
import {cs}       from "@Common/react/chain-services";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faChevronDown,
    faMinus,
    faPlus,
}                  from '@fortawesome/free-solid-svg-icons';

import {UseState}           from "@Common/react/use-state";
import {is3rdPartyWorkflow} from "@Common/logic/item/is-3rd-party";
import {isPickPack}         from "@Common/logic/item/is-pick-pack";
import {oMapToArr}          from "@Common/utils/objects";

import {DeliveryStatus}        from "../../delivery-status/delivery-status";
import {ThumbnailPreviewModal} from "../../thumbnail-preview-modal/thumbnail-preview-modal";
import "./kit-details.scss";

const DELIVERY_TYPES_TRACEABLE = ["Mailed", "Shipped"];

export const KitDetails = ({item,displayKitOptions}) => cs(
    ["deliveryStatus", ({}, next) => DeliveryStatus({next})],
    ["expandedState", ({}, next) => UseState({
        initValue: [],
        next,
    })],
    ["view", (_, next) => UseState({
        initValue: {enlarged: false, key: 0},
        next,
    })],
    ["enlargedView", ({}, next) => (
        ThumbnailPreviewModal({renderSibling: next})
    )],
    ({deliveryStatus, expandedState, enlargedView}) => (
        <div className="kit-details-kd7 kit-details">
            <div className="header">
                <div className="collapse-list" xd-qa-type="icon" xd-qa-name="Collapse">
                    {(expandedState.value.length === 0) ? (
                        <FontAwesomeIcon key={"header faPlus"} className="icon" icon={faPlus} onClick={() =>
                            expandedState.onChange(oMapToArr(item.components,(value, key:string) => (key)))
                        }/>
                    ) : (
                        <FontAwesomeIcon key={"header faMinus"} className="icon" icon={faMinus} onClick={() =>
                            expandedState.onChange([])
                        }/>
                    )}
                </div>
                KIT COMPONENTS
            </div>
            <hr className="separator"/>
            <div className="kit-list">
                {item.components && Object.keys(item.components).map((key, i) => {
                    const component = item.components[key];
                    component.itemId = item.itemId;
                    return (component?.selections?.quantity > 0 &&
                        <div
                            key={i}
                            className="main-item" 
                            xd-qa-type="card" 
                            xd-qa-name={component.itemName}
                        >
                            <div className="kit-card">
                                <div className="card-left">
                                    {(component.selections.options?.filter((o) => (
                                        (!isPickPack(component) && !is3rdPartyWorkflow(component)) ? o : o?.dev_key !== "paper_type")
                                    ).length > 0 || component.deliveryStatus || item.deliveryStatus ) && <div className="collapse-arrow">
                                        <a>
                                            <FontAwesomeIcon
                                                key={key + "Chevron"}
                                                className={cx("icon", {collapsed: expandedState.value.find((p) => p === key) !== undefined})}
                                                icon={faChevronDown}
                                                onClick={() => expandedState.onChange(
                                                    expandedState.value.find((p) => p === key) ? (
                                                        expandedState.value.filter((p) => p !== key)
                                                    ) : (
                                                        [...expandedState.value, key]
                                                    )
                                                )}
                                                xd-qa-type="icon"
                                                xd-qa-name="Collapse"
                                            />
                                        </a>
                                    </div>}
                                </div>
                                <div className="card-middle">
                                    <div className="name" xd-qa-type="text" xd-qa-name={component.itemName}>
                                        {component.itemName ? component.itemName : item.itemName}
                                    </div>
                                    <div className="quantity-line">
                                        <div className="label">
                                            QTY included in Kit
                                        </div>
                                        <div className="quantity" xd-qa-type="text" xd-qa-name="Quantity">
                                            {component.selections.quantity}
                                        </div>
                                    </div>
                                </div>
                                <div className="card-right">
                                    <div className="thumbnail" xd-qa-type="icon" xd-qa-name="Preview">
                                        {component?.proofUrls || component?.itemThumbnails || component.thumbnail ? (
                                            <img src={
                                                component?.proofUrls?.jpg ? (
                                                    component?.proofUrls?.jpg?.[0]?.path
                                                ) : component?.itemThumbnails ? (
                                                    component?.itemThumbnails?.[0]
                                                ) : (
                                                    component.thumbnail
                                                )
                                            } alt={component.itemName} onClick={() => enlargedView.show(
                                                component?.proofUrls?.jpg ? (
                                                    component?.proofUrls?.jpg
                                                ) : component?.itemThumbnails ? (
                                                    component?.itemThumbnails.map((thumbnail) => ({"url": thumbnail}))
                                                ) : (
                                                    [{"url": component.thumbnail}]
                                                )
                                            )}/>
                                        ) : (
                                            <img src={require("../../../../../../../public/assets/NoImageAvailable.png")} alt="No Image Available"/>
                                        )}
                                    </div>
                                </div>
                            </div>
                            {expandedState.value.includes(key) && <div className="selections-list">
                                {displayKitOptions && ( component.deliveryStatus || item.deliveryStatus ) && <div className="kit-details-line">
                                    <div className="label" xd-qa-type="label" xd-qa-name="Status">
                                        Status
                                    </div>
                                    {DELIVERY_TYPES_TRACEABLE.includes(component.deliveryStatus) ? (
                                            <a
                                                className="link"
                                                xd-qa-type="link"
                                                xd-qa-name="Status"
                                                onClick={async () => deliveryStatus.show({component})}
                                            >
                                                {component.deliveryStatus}
                                            </a>
                                        ) : (
                                            <div className="value bold" xd-qa-type="label" xd-qa-name="Status">{component.transOrderStatus === "cancelled" ? "Cancelled" : component.deliveryStatus ?? item.deliveryStatus}</div>
                                        )
                                    }
                                </div>}
                                {component.selections.options?.filter(
                                    (o) => ((!isPickPack(component) && !is3rdPartyWorkflow(component)) ? o : o?.dev_key !== "paper_type")
                                )?.map((o) => (
                                    isJson(o?.name) ? (
                                        oMapToArr(JSON.parse(o.name),(value, key:string) => (<>
                                        <hr />
                                        <div className="kit-details-line">
                                            <div className="label" xd-qa-type="label" xd-qa-name={key}>{key}</div>
                                            <div className="value bold" xd-qa-type="label" xd-qa-name={value}>{value}</div>
                                        </div></>))
                                    ) : (<>
                                        <hr />
                                        <div className="kit-details-line">
                                            <div className="label" xd-qa-type="label" xd-qa-name={capitalizeWords(o?.group)}>{capitalizeWords(o?.group)}</div>
                                            <div className="value bold" xd-qa-type="label" xd-qa-name={o?.name}>{o?.name}</div>
                                        </div>
                                    </>)
                                ))}
                            </div>}
                        </div>
                    )
                })}
            </div>
        </div>
    )
)

const isJson = (string) => {
    try {
        JSON.parse(string);
        return true;
    } catch (error) {
        return false;
    }
}

const capitalizeWords = (str) => {
    if(!str) {
        return ''
    }
    return str.replace(/\w+/g, (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());
}
